import { useMemo } from 'react'
import { useAppSelector } from '.'
import { getMarkets } from '@App/redux/slices/sockets/PublicServiceConnectionSlice'

export const useMarkets = () => {
  const config = useAppSelector((state) => state.config)

  const socketMarkets = useAppSelector((state) => getMarkets(state))

  const markets = useMemo(() => {
    const baseMarkets = config.markets || []

    if (!socketMarkets || socketMarkets.length === 0) {
      return baseMarkets
    }

    const marketsMap = new Map(baseMarkets.map((m) => [m.id, m]))

    socketMarkets.forEach((socketMarket) => {
      marketsMap.delete(socketMarket.id)
      marketsMap.set(socketMarket.id, socketMarket)
    })

    return Array.from(marketsMap.values()).sort((a, b) => a.id - b.id)
  }, [config.markets, socketMarkets])

  return markets
}
